export default __webpack_public_path__ + "static/media/image-8.a47c8395.png";